import type { ThemeConfig } from 'antd';
import { PW } from './tokens';

/**
 * 파크웨이브 엔터프라이즈 테마. 토큰은 `theme/tokens.ts`가 정본.
 */
export const enterpriseTheme: ThemeConfig = {
  token: {
    colorPrimary: PW.color.primary,
    colorInfo: PW.color.info,
    colorSuccess: PW.color.success,
    colorWarning: PW.color.warning,
    colorError: PW.color.error,
    colorText: PW.color.ink,
    colorTextSecondary: PW.color.muted,
    colorBorder: PW.color.lineStrong,
    colorSplit: PW.color.line,
    colorBgLayout: PW.color.canvas,
    colorLink: PW.color.primary,
    borderRadius: PW.radius.sm,
    wireframe: false,
    fontFamily: PW.font.sans,
    fontFamilyCode: PW.font.code,
    controlHeight: 36,
  },
  components: {
    Card: { headerBg: PW.color.surface },
    Table: {
      headerBg: '#f1f5f9',
      headerColor: PW.color.ink,
      borderColor: PW.color.line,
      rowHoverBg: PW.color.surface,
    },
    Layout: {
      bodyBg: PW.color.canvas,
      headerBg: PW.color.card,
      footerBg: PW.color.surface,
      siderBg: PW.color.sider,
    },
    Menu: {
      darkItemBg: PW.color.sider,
      darkSubMenuItemBg: PW.color.sider,
      darkItemSelectedBg: '#164e63',
      darkItemHoverBg: '#12202c',
    },
    Button: {
      primaryShadow: 'none',
    },
  },
};
